export const APP_MASONRY_GALERY_ORIENTATION = ['horizontal', 'vertical'];

export type AppMasonryGalleryOrientation =
  (typeof APP_MASONRY_GALERY_ORIENTATION)[number];

export enum GalleryButtonType {
  NoButton = 'no-button',
  IconButton = 'icon-button',
  TextAndIconButton = 'text-and-icon-button',
}

interface NoButton {
  type: GalleryButtonType.NoButton;
}

interface IconButton {
  type: GalleryButtonType.IconButton;
  ariaLabel: string;
}

interface TextAndIconButton {
  type: GalleryButtonType.TextAndIconButton;
  text: string;
}

export type GalleryButton = NoButton | IconButton | TextAndIconButton;
